// BettingBanner.jsx
import React from "react";

const BettingBanner = ({ totalBets, liveBets, pastBets }) => {
  return (
    <div className="w-100">
      <svg
        width="100%"
        height="236"
        viewBox="0 0 754 236"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="55" width="588" height="236" rx="46.5429" fill="#5219A7" />
        <path
          d="M1 12.4114C1 5.55678 6.55679 0 13.4114 0H741.589C748.443 0 754 5.55679 754 12.4114V223.589C754 230.443 748.443 236 741.589 236H13.4114C6.55679 236 1 230.443 1 223.589V12.4114Z"
          fill="#6C2DCA"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.4114 0H125.262V74.9061H0.313248V9.62834C1.57664 4.11371 6.51363 0 12.4114 0ZM175.159 74.9061V0H741.589C748.443 0 754 5.55679 754 12.4114V109.54C745.532 107.232 736.625 106 727.433 106C671.413 106 626 151.737 626 208.157C626 217.809 627.329 227.149 629.813 236H12.4114C5.55678 236 0 230.443 0 223.589V124.803H0.313248H125.262H175.159V74.9061Z"
          fill="#5219A7"
        />
        <text
          fill="white"
          style={{ whiteSpace: "pre" }}
          font-family="Montserrat"
          font-size="24.9486"
          font-weight="bold"
          letter-spacing="0em"
        >
          <tspan x="79" y="181.944">
            MY STAKES
          </tspan>
        </text>
        <text
          opacity="0.75"
          fill="white"
          style={{ whiteSpace: "pre" }}
          font-family="Montserrat"
          font-size="17.963"
          font-weight="600"
          letter-spacing="0em"
        >
          <tspan x="79" y="207.373">
            {totalBets || 0} STAKES
          </tspan>
        </text>
        <path
          d="M664.854 95.2615L650.496 85.5039V127.537L669.311 145.551L664.854 95.2615Z"
          fill="#FB5A21"
        />
        <path
          d="M605.355 95.2693L618.324 85.5117V127.544L601.33 145.559L605.355 95.2693Z"
          fill="#FB5A21"
        />
        <path
          d="M634.711 145.597V136.623V127.649V31.9258C634.711 31.9258 625.541 37.8694 619.305 66.1014C615.718 82.3429 614.09 97.5073 613.177 113.44C612.59 123.678 612.917 134.379 613.39 145.597H617.654V151.58H622.653V157.562H634.711V151.58V145.597Z"
          fill="#DCDFD9"
        />
        <path
          d="M634.711 145.597V136.623V127.649V31.9258C634.711 31.9258 644.136 37.8694 650.545 66.1014C654.232 82.3429 655.904 97.5073 656.843 113.44C657.447 123.678 657.111 134.379 656.624 145.597H652.241V151.58H647.104V157.562H634.711V151.58V145.597Z"
          fill="#F9F1F9"
        />
        <path
          d="M629.872 166.789C633.096 166.789 635.329 166.789 640.785 166.789C646.79 166.789 642.273 193.123 640.785 193.123C639.297 193.123 635.329 203.741 635.329 203.741C635.329 203.741 632.104 193.123 629.872 193.123C627.64 193.123 624.301 166.789 629.872 166.789Z"
          fill="#E36018"
        />
        <path
          d="M630.821 166.789C633.484 166.789 635.328 166.789 639.835 166.789C644.796 166.789 641.065 186.539 639.835 186.539C638.606 186.539 635.328 194.503 635.328 194.503C635.328 194.503 632.664 186.539 630.821 186.539C628.977 186.539 626.218 166.789 630.821 166.789Z"
          fill="#FFAE44"
        />
        <path
          d="M632.243 166.789C634.066 166.789 635.327 166.789 638.412 166.789C641.806 166.789 639.253 179.956 638.412 179.956C637.57 179.956 635.327 185.265 635.327 185.265C635.327 185.265 633.505 179.956 632.243 179.956C630.982 179.956 629.095 166.789 632.243 166.789Z"
          fill="#FCE25E"
        />
        <path
          d="M624.998 157.562H645.027L643.813 168.648H626.819L624.998 157.562Z"
          fill="#5B6575"
        />
        <path
          d="M640.304 63.3354C640.304 66.7076 639.398 69.5659 638.158 71.4542C636.894 73.3781 635.632 73.8676 634.842 73.8676C634.052 73.8676 632.79 73.3781 631.526 71.4542C630.285 69.5659 629.379 66.7076 629.379 63.3354C629.379 59.9633 630.285 57.105 631.526 55.2167C632.79 53.2928 634.052 52.8032 634.842 52.8032C635.632 52.8032 636.894 53.2928 638.158 55.2167C639.398 57.105 640.304 59.9633 640.304 63.3354Z"
          fill="#00D5CC"
          stroke="#5B6575"
          stroke-width="8.4971"
        />
        <path
          d="M630.35 96.3213L634.598 86.4257L638.847 96.3213L634.598 159.406L630.35 96.3213Z"
          fill="#FB5A21"
        />
        <path
          d="M680.453 48.2139L678.126 45.8867L675.799 48.2139L678.126 50.541L680.453 48.2139Z"
          fill="#C2B643"
        />
        <path
          d="M553.654 42.3272L551.327 40L549 42.3272L551.327 44.6543L553.654 42.3272Z"
          fill="#C2B643"
        />
        <path
          d="M553.654 195.327L551.327 193L549 195.327L551.327 197.654L553.654 195.327Z"
          fill="#C2B643"
        />
        <path
          d="M683.557 10.9795L681.229 8.65234L678.902 10.9795L681.229 13.3066L683.557 10.9795Z"
          fill="#32BC40"
        />
        <path
          d="M629.256 12.5342L626.929 10.207L624.602 12.5342L626.929 14.8613L629.256 12.5342Z"
          fill="#B7AA32"
        />
        <path
          d="M596.676 118.03L594.349 115.703L592.021 118.03L594.349 120.357L596.676 118.03Z"
          fill="#D14DD3"
        />
        <path
          d="M573.654 136.327L571.327 134L569 136.327L571.327 138.654L573.654 136.327Z"
          fill="#C2B643"
        />
        <path
          d="M669.594 77.6944L667.267 75.3672L664.939 77.6944L667.267 80.0215L669.594 77.6944Z"
          fill="#D14DD3"
        />
        <path
          d="M596.676 37.3545L594.349 35.0273L592.021 37.3545L594.349 39.6816L596.676 37.3545Z"
          fill="#32BC40"
        />
        <path
          d="M568.654 58.3272L566.327 56L564 58.3272L566.327 60.6543L568.654 58.3272Z"
          fill="#D14DD3"
        />
        <path
          d="M553.654 116.327L551.327 114L549 116.327L551.327 118.654L553.654 116.327Z"
          fill="#D14DD3"
        />
        <path
          d="M613.742 54.4209L611.415 52.0938L609.088 54.4209L611.415 56.748L613.742 54.4209Z"
          fill="#28ADAD"
        />
        <path
          d="M596.676 195.601L594.349 193.273L592.021 195.601L594.349 197.928L596.676 195.601Z"
          fill="#28ADAD"
        />
        <path
          d="M576.654 214.327L574.327 212L572 214.327L574.327 216.654L576.654 214.327Z"
          fill="#C2B643"
        />
        <path
          d="M596.676 77.6944L594.349 75.3672L592.021 77.6944L594.349 80.0215L596.676 77.6944Z"
          fill="#C2B643"
        />
        <path
          d="M582.654 97.3272L580.327 95L578 97.3272L580.327 99.6543L582.654 97.3272Z"
          fill="#C2B643"
        />
        <path
          d="M725.654 63.3272L723.327 61L721 63.3272L723.327 65.6543L725.654 63.3272Z"
          fill="#C2B643"
        />
        <path
          d="M686.658 107.171L684.331 104.844L682.004 107.171L684.331 109.498L686.658 107.171Z"
          fill="#28ADAD"
        />
        <path
          d="M603.654 163.327L601.327 161L599 163.327L601.327 165.654L603.654 163.327Z"
          fill="#A39941"
        />
        <path
          d="M577.654 171.327L575.327 169L573 171.327L575.327 173.654L577.654 171.327Z"
          fill="#D14DD3"
        />
        <path
          d="M596.676 6.3272L594.349 4L592.021 6.3272L594.349 8.65429L596.676 6.3272Z"
          fill="#28ADAD"
        />
        <path
          d="M596.654 6.3272L594.327 4L592 6.3272L594.327 8.65429L596.654 6.3272Z"
          fill="#28ADAD"
        />
        <path
          d="M553.654 159.327L551.327 157L549 159.327L551.327 161.654L553.654 159.327Z"
          fill="#28ADAD"
        />
        <path
          d="M578.654 23.3272L576.327 21L574 23.3272L576.327 25.6543L578.654 23.3272Z"
          fill="#C2B643"
        />
        <path
          d="M704.654 85.3272L702.327 83L700 85.3272L702.327 87.6543L704.654 85.3272Z"
          fill="#28ADAD"
        />
        <path
          d="M553.654 231.327L551.327 229L549 231.327L551.327 233.654L553.654 231.327Z"
          fill="#28ADAD"
        />
        <path
          d="M553.654 80.3272L551.327 78L549 80.3272L551.327 82.6543L553.654 80.3272Z"
          fill="#28ADAD"
        />
        <path
          d="M720.654 8.3272L718.327 6L716 8.3272L718.327 10.6543L720.654 8.3272Z"
          fill="#28ADAD"
        />
        <path
          d="M618.396 149.058L616.069 146.73L613.742 149.058L616.069 151.385L618.396 149.058Z"
          fill="#6C2DCA"
        />
        <path
          d="M601.654 228.327L599.327 226L597 228.327L599.327 230.654L601.654 228.327Z"
          fill="#D14DD3"
        />
        <path
          d="M655.631 28.0459L653.304 25.7188L650.977 28.0459L653.304 30.373L655.631 28.0459Z"
          fill="#D14DD3"
        />
        <path
          d="M706.654 37.3272L704.327 35L702 37.3272L704.327 39.6543L706.654 37.3272Z"
          fill="#D14DD3"
        />
        <path
          d="M553.654 9.3272L551.327 7L549 9.3272L551.327 11.6543L553.654 9.3272Z"
          fill="#D14DD3"
        />
        <text
          fill="#FFC846"
          style={{ whiteSpace: "pre" }}
          font-family="Montserrat"
          font-size="17.963"
          font-weight="600"
          letter-spacing="0em"
        >
          <tspan x="260.553" y="179.44">
            Live Stakes: {liveBets || 0}
          </tspan>
        </text>
        <text
          fill="#57F417"
          style={{ whiteSpace: "pre" }}
          font-family="Montserrat"
          font-size="17.963"
          font-weight="600"
          letter-spacing="0em"
        >
          <tspan x="260.553" y="202.709">
            Completed Stakes: {pastBets || 0}
          </tspan>
        </text>
        <circle cx="248.141" cy="172.858" r="6.20571" fill="url(#paint0_linear_23_8)" />
        <circle cx="248.141" cy="196.131" r="6.20571" fill="url(#paint1_linear_23_8)" />
        <path
          d="M118.347 23.8203C108.572 24.1844 99.2497 28.0365 92.0664 34.6783L99.5223 42.1361C104.721 37.4631 111.367 34.7202 118.347 34.3678V23.8203Z"
          fill="#F1BB94"
        />
        <path
          d="M97.2213 85.3909C92.4975 80.1784 89.723 73.4913 89.3687 66.4648H78.8242C79.1904 76.2868 83.0747 85.6493 89.7682 92.8461L97.2213 85.3909Z"
          fill="#F1BB94"
        />
        <path
          d="M150.062 36.9769L142.607 44.4318C147.332 49.6443 150.106 56.3321 150.461 63.3579H161.005C160.64 53.5359 156.755 44.1734 150.062 36.9766V36.9769Z"
          fill="#F1BB94"
        />
        <path
          d="M118.346 105.998V95.4522C111.321 95.0978 104.635 92.3227 99.4225 87.5977L91.9688 95.0526C99.1636 101.748 108.525 105.633 118.346 105.998H118.346Z"
          fill="#F1BB94"
        />
        <path
          d="M147.83 34.7667C140.636 28.0714 131.274 24.1866 121.453 23.8203V34.3664C128.479 34.7215 135.165 37.4972 140.376 42.2224L147.83 34.7667Z"
          fill="#F1BB94"
        />
        <path
          d="M97.3097 44.3324L89.8573 36.8789C83.1094 44.0866 79.1917 53.4889 78.8242 63.3547H89.3687C89.7251 56.2833 92.5332 49.5573 97.3097 44.3324Z"
          fill="#F1BB94"
        />
        <path
          d="M119.914 92.3748C135.056 92.3748 147.374 80.0548 147.374 64.9081C147.374 49.7628 135.056 37.4414 119.914 37.4414C104.772 37.4414 92.4531 49.7636 92.4531 64.9081C92.4531 80.0527 104.772 92.3731 119.914 92.3731V92.3748ZM106.286 64.0437L118.617 45.5846V45.5853C118.906 45.1523 119.392 44.8926 119.913 44.8926C120.434 44.8926 120.92 45.1523 121.209 45.5853L133.54 64.0462C133.89 64.5704 133.89 65.2541 133.54 65.7784L121.209 84.2392C120.92 84.6722 120.434 84.9319 119.913 84.9319C119.392 84.9319 118.906 84.6722 118.617 84.2392L106.286 65.7801V65.7808C105.935 65.2559 105.935 64.5708 106.286 64.0459V64.0437Z"
          fill="#F1BB94"
        />
        <path
          d="M150.454 66.4648C150.102 73.4464 147.36 80.0938 142.688 85.2929L150.143 92.7499C156.784 85.5657 160.636 76.2423 161 66.4648H150.454Z"
          fill="#F1BB94"
        />
        <path
          d="M121.453 106C131.318 105.632 140.718 101.713 147.925 94.9652L140.472 87.5117C135.248 92.2891 128.523 95.0969 121.453 95.4534V106Z"
          fill="#F1BB94"
        />
        <path
          d="M130.341 64.9144L119.885 49.2617L109.43 64.9144L119.885 80.5664L130.341 64.9144Z"
          fill="#F1BB94"
        />
        <g opacity="0.75">
          <path
            d="M202.973 34.1016C195.641 34.3747 188.649 37.2637 183.262 42.2451L188.854 47.8384C192.753 44.3337 197.737 42.2765 202.973 42.0122V34.1016Z"
            fill="#64FFE3"
          />
          <path
            d="M187.128 80.2844C183.585 76.375 181.504 71.3597 181.239 66.0898H173.33C173.605 73.4563 176.518 80.4782 181.538 85.8758L187.128 80.2844Z"
            fill="#64FFE3"
          />
          <path
            d="M226.759 43.9651L221.168 49.5563C224.711 53.4656 226.792 58.4815 227.058 63.7508H234.966C234.692 56.3843 231.779 49.3625 226.759 43.9648V43.9651Z"
            fill="#64FFE3"
          />
          <path
            d="M202.972 95.738V87.8284C197.703 87.5626 192.689 85.4813 188.78 81.9375L183.189 87.5287C188.586 92.5502 195.606 95.4638 202.973 95.738H202.972Z"
            fill="#64FFE3"
          />
          <path
            d="M225.082 42.3114C219.686 37.2899 212.664 34.3763 205.299 34.1016V42.0111C210.568 42.2774 215.583 44.3592 219.491 47.9031L225.082 42.3114Z"
            fill="#64FFE3"
          />
          <path
            d="M187.194 49.4847L181.605 43.8945C176.544 49.3003 173.606 56.352 173.33 63.7514H181.239C181.506 58.4478 183.612 53.4034 187.194 49.4847Z"
            fill="#64FFE3"
          />
          <path
            d="M204.145 85.5165C215.501 85.5165 224.74 76.2765 224.74 64.9164C224.74 53.5575 215.501 44.3164 204.145 44.3164C192.788 44.3164 183.549 53.558 183.549 64.9164C183.549 76.2749 192.788 85.5151 204.145 85.5151V85.5165ZM193.924 64.2681L203.172 50.4238V50.4244C203.389 50.0996 203.753 49.9048 204.144 49.9048C204.534 49.9048 204.899 50.0996 205.116 50.4244L214.364 64.27C214.627 64.6632 214.627 65.1759 214.364 65.5691L205.116 79.4148C204.899 79.7395 204.534 79.9343 204.144 79.9343C203.753 79.9343 203.389 79.7395 203.172 79.4148L193.924 65.5705V65.571C193.66 65.1773 193.66 64.6635 193.924 64.2698V64.2681Z"
            fill="#64FFE3"
          />
          <path
            d="M227.051 66.0898C226.787 71.326 224.731 76.3115 221.227 80.2108L226.819 85.8036C231.799 80.4155 234.688 73.4229 234.961 66.0898H227.051Z"
            fill="#64FFE3"
          />
          <path
            d="M205.299 95.7334C212.698 95.4577 219.748 92.5185 225.153 87.4573L219.563 81.8672C215.645 85.4502 210.601 87.5561 205.299 87.8234V95.7334Z"
            fill="#64FFE3"
          />
          <path
            d="M211.967 64.9231L204.125 53.1836L196.283 64.9231L204.125 76.6621L211.967 64.9231Z"
            fill="#64FFE3"
          />
        </g>
        <g opacity="0.5">
          <path
            d="M267.057 44.375C262.169 44.5571 257.508 46.4831 253.916 49.804L257.644 53.5328C260.243 51.1964 263.567 49.8249 267.057 49.6487V44.375Z"
            fill="#F156FF"
          />
          <path
            d="M256.494 75.1622C254.132 72.5559 252.744 69.2124 252.567 65.6992H247.295C247.478 70.6102 249.42 75.2914 252.767 78.8898L256.494 75.1622Z"
            fill="#F156FF"
          />
          <path
            d="M282.917 50.9494L279.189 54.6768C281.552 57.283 282.939 60.6269 283.116 64.1398H288.389C288.206 59.2288 286.264 54.5476 282.917 50.9492V50.9494Z"
            fill="#F156FF"
          />
          <path
            d="M267.056 85.4659V80.1928C263.543 80.0157 260.2 78.6281 257.594 76.2656L253.867 79.9931C257.465 83.3407 262.145 85.2831 267.056 85.4659H267.056Z"
            fill="#F156FF"
          />
          <path
            d="M281.796 49.8482C278.199 46.5005 273.518 44.5581 268.607 44.375V49.648C272.12 49.8255 275.463 51.2134 278.069 53.5759L281.796 49.8482Z"
            fill="#F156FF"
          />
          <path
            d="M256.538 54.6252L252.812 50.8984C249.438 54.5023 247.479 59.2033 247.295 64.1362H252.567C252.746 60.6006 254.15 57.2376 256.538 54.6252Z"
            fill="#F156FF"
          />
          <path
            d="M267.838 78.6501C275.41 78.6501 281.569 72.4901 281.569 64.9168C281.569 57.3443 275.409 51.1836 267.838 51.1836C260.267 51.1836 254.107 57.3446 254.107 64.9168C254.107 72.4891 260.267 78.6492 267.838 78.6492V78.6501ZM261.024 64.4846L267.19 55.2552V55.2555C267.335 55.039 267.577 54.9092 267.838 54.9092C268.098 54.9092 268.341 55.039 268.486 55.2555L274.651 64.4859C274.826 64.748 274.826 65.0898 274.651 65.3519L268.486 74.5823C268.341 74.7988 268.098 74.9287 267.838 74.9287C267.577 74.9287 267.335 74.7988 267.19 74.5823L261.024 65.3528V65.3532C260.848 65.0907 260.848 64.7482 261.024 64.4857V64.4846Z"
            fill="#F156FF"
          />
          <path
            d="M283.112 65.6992C282.936 69.19 281.565 72.5136 279.229 75.1131L282.957 78.8416C286.277 75.2496 288.203 70.5879 288.385 65.6992H283.112Z"
            fill="#F156FF"
          />
          <path
            d="M268.607 85.4628C273.54 85.279 278.24 83.3196 281.844 79.9455L278.117 76.2188C275.505 78.6074 272.142 80.0113 268.607 80.1895V85.4628Z"
            fill="#F156FF"
          />
          <path
            d="M273.054 64.92L267.826 57.0938L262.598 64.92L267.826 72.746L273.054 64.92Z"
            fill="#F156FF"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_23_8"
            x1="241.936"
            y1="166.652"
            x2="256.71"
            y2="170.961"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF6B00" />
            <stop offset="1" stop-color="#DDAC00" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_23_8"
            x1="241.936"
            y1="189.926"
            x2="256.71"
            y2="194.234"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#DBFF00" />
            <stop offset="1" stop-color="#00ED26" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default BettingBanner;
